import { useState } from "react";
import { Star, Quote, ChevronLeft, ChevronRight } from "lucide-react";
import { TESTIMONIALS } from "@/lib/brand";

export const Testimonials = () => {
  const [index, setIndex] = useState(0);
  const total = TESTIMONIALS.length;

  const prev = () => setIndex((i) => (i - 1 + total) % total);
  const next = () => setIndex((i) => (i + 1) % total);

  const visible = [
    TESTIMONIALS[index],
    TESTIMONIALS[(index + 1) % total],
    TESTIMONIALS[(index + 2) % total],
  ];

  return (
    <section
      id="testimonials"
      data-testid="testimonials-section"
      className="relative bg-[#050505] py-24 md:py-32 px-6 md:px-12 border-t border-white/5"
    >
      <div className="max-w-[1400px] mx-auto">
        <div className="flex flex-col md:flex-row md:items-end justify-between gap-8 mb-16">
          <div className="max-w-2xl">
            <div className="flex items-center gap-3 mb-6">
              <span className="h-px w-12 bg-yellow-500" />
              <span className="text-yellow-500 text-xs uppercase tracking-[0.4em]">
                03 — Témoignages
              </span>
            </div>
            <h2 className="font-display text-white text-5xl md:text-6xl leading-[0.95]">
              Ce qu'en disent<br />
              <span className="text-stroke-yellow">nos clients.</span>
            </h2>
          </div>
          <div className="flex items-center gap-3">
            <button
              onClick={prev}
              data-testid="testimonials-prev"
              aria-label="Avis précédent"
              className="w-12 h-12 border border-white/20 hover:border-yellow-500 hover:bg-yellow-500 hover:text-black text-white flex items-center justify-center transition-colors"
            >
              <ChevronLeft className="w-5 h-5" />
            </button>
            <button
              onClick={next}
              data-testid="testimonials-next"
              aria-label="Avis suivant"
              className="w-12 h-12 border border-white/20 hover:border-yellow-500 hover:bg-yellow-500 hover:text-black text-white flex items-center justify-center transition-colors"
            >
              <ChevronRight className="w-5 h-5" />
            </button>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-4 md:gap-5">
          {visible.map((t, i) => (
            <article
              key={`${index}-${i}`}
              data-testid={`testimonial-card-${i}`}
              className={`relative bg-[#0d0d0d] border border-white/10 p-8 flex flex-col fade-up ${
                i === 0 ? "md:border-yellow-500/40" : ""
              }`}
              style={{ animationDelay: `${i * 0.1}s` }}
            >
              <Quote className="w-8 h-8 text-yellow-500/40 mb-4" />

              <div className="flex items-center gap-1 mb-4">
                {Array.from({ length: t.rating }).map((_, k) => (
                  <Star key={k} className="w-4 h-4 fill-yellow-500 text-yellow-500" />
                ))}
              </div>

              <p className="text-zinc-200 text-base leading-relaxed mb-6 flex-1">
                « {t.text} »
              </p>

              <div className="pt-6 border-t border-white/10">
                <div className="font-display text-xl text-white tracking-wide">{t.name}</div>
                <div className="text-sm text-zinc-400 mt-1">{t.vehicle}</div>
                <div className="text-[10px] uppercase tracking-[0.25em] text-yellow-500 mt-2">
                  {t.service}
                </div>
              </div>
            </article>
          ))}
        </div>

        <div className="mt-10 flex items-center justify-center gap-2">
          {TESTIMONIALS.map((_, i) => (
            <button
              key={i}
              onClick={() => setIndex(i)}
              aria-label={`Aller au témoignage ${i + 1}`}
              className={`h-1 transition-all ${
                i === index ? "w-10 bg-yellow-500" : "w-5 bg-white/20 hover:bg-white/40"
              }`}
              data-testid={`testimonials-dot-${i}`}
            />
          ))}
        </div>
      </div>
    </section>
  );
};
